import React from "react";
import CommonLogin from "./CommonLogin";
import Home from "./Home";
import Finance from "./Finance";
import Payouts from "./Payouts";
import Reviews from "./Reviews";
import Settings from "./Settings";
import ProviderDetailsPage from "./ProviderDetailsPage";
import UserDetailsPage from "./UserDetailsPage";
import VerifiedBuddies from "./VerifiedBuddies";
import UnverifiedBuddies from "./UnverifiedBuddies";
import Services from "./Services";
import Users from "./Users";
import Bookings from "./Bookings";
import LiveBookings from "./LiveBookings";
import CityPricing from "./CityPricing";
import Staff from "./Staff";
import StaffProvider from "./staff/staffprovider";
import StaffServices from "./staff/StaffServices";
import StaffLayout from "./staff/StaffLayout";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

function isAdminAuthenticated() {
  return !!localStorage.getItem("token");
}

function isStaffAuthenticated() {
  return !!localStorage.getItem("staffToken");
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<CommonLogin />} />
        <Route
          path="/"
          element={
            isAdminAuthenticated() ? <Home /> : <Navigate to="/login" replace />
          }
        />

        {/* Admin Routes */}
        <Route
          path="/admin/home"
          element={
            isAdminAuthenticated() ? <Home /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/admin/finance"
          element={
            isAdminAuthenticated() ? (
              <Finance />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/payouts"
          element={
            isAdminAuthenticated() ? (
              <Payouts />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/reviews"
          element={
            isAdminAuthenticated() ? (
              <Reviews />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/settings"
          element={
            isAdminAuthenticated() ? (
              <Settings />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/provider/:id"
          element={
            isAdminAuthenticated() ? (
              <ProviderDetailsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/provider/:id/:type"
          element={
            isAdminAuthenticated() ? (
              <ProviderDetailsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/verified-buddies"
          element={
            isAdminAuthenticated() ? (
              <VerifiedBuddies />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/unverified-buddies"
          element={
            isAdminAuthenticated() ? (
              <UnverifiedBuddies />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/services"
          element={
            isAdminAuthenticated() ? (
              <Services />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/city-pricing"
          element={
            isAdminAuthenticated() ? (
              <CityPricing />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/users"
          element={
            isAdminAuthenticated() ? (
              <Users />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/bookings"
          element={
            isAdminAuthenticated() ? (
              <Bookings />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/live-bookings"
          element={
            isAdminAuthenticated() ? (
              <LiveBookings />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/user/:id"
          element={
            isAdminAuthenticated() ? (
              <UserDetailsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/staff"
          element={
            isAdminAuthenticated() ? (
              <Staff />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Staff Routes */}
        <Route
          path="/staff/*"
          element={
            isStaffAuthenticated() ? (
              <StaffLayout>
                <Routes>
                  <Route path="dashboard" element={<StaffProvider />} />
                  <Route path="services" element={<StaffServices />} />
                </Routes>
              </StaffLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}
